import BrowserStorage from "PFCore/base/storage/browser_storage";
import MemoryStorage from "PFCore/base/storage/memory_storage";

const resetStorage = () => {
  try {
    window.localStorage.setItem("ping", "pong");
    window.storage = new BrowserStorage();
  } catch {
    window.storage = new MemoryStorage();
  }
};

resetStorage();
